<template>
  <div>
    <BlankScreen v-show="showForm" />
    <AppBarLight
      current-section="about"
      :class="`${showForm || showOurStory ? 'hidden' : ''}`"
      @get-in-touch="showForm = true"
    />
    <div class="spacing" />
    <AboutHeader />
    <AboutLinkAndDescription @open-our-story="showOurStory = true" />
    <BigBrain />
    <AboutDescription />
    <AboutCulture @open-our-story="showOurStory = true" />
    <AboutCredo
      v-if="credoEntries.length > 0"
      :query="queryParams"
      :services="credoEntries"
    />
    <ContactUsFooter
      @open-form="handleFormRequest"
    />
    <transition name="fade">
      <ContactUsHolder
        v-if="showForm"
        :name="contactInfo.name"
        :email="contactInfo.email"
        :company="contactInfo.company"
        @close-form="closeForm"
      />
    </transition>
    <transition name="fade">
      <OurStory
        v-if="showOurStory && storyEntries.length > 0"
        :histories="storyEntries"
        @close-form="showOurStory = false"
      />
    </transition>
    <Footer
      @get-in-touch="openForm"
    />
    <PrivacyPolicyBanner />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, inject, computed} from 'vue';
import AppBarLight from '../components/general/AppBarLight.vue';
import ContactUsFooter from '../components/general/ContactUsFooter.vue';
import ContactUsHolder from '../components/contact_us_form/ContactUsHolder.vue';
import AboutDescription from '../components/about/AboutDescription.vue';
import AboutHeader from '../components/about/AboutHeader.vue';
import AboutLinkAndDescription from '../components/about/AboutLinkAndDescription.vue';
import BigBrain from '../components/about/BigBrain.vue';
import Footer from '../components/general/Footer.vue';
import AboutCredo from '../components/about/AboutCredo.vue';
import OurStory from '../components/our_story/OurStory.vue';
import AboutCulture from '../components/about/AboutCulture.vue';
import PrivacyPolicyBanner from '../components/general/PrivacyPolicyBanner.vue';
import BlankScreen from '../components/general/BlankScreen.vue';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import axios from 'axios';
import { cdn } from '../support/cdn';

gsap.registerPlugin(ScrollToPlugin);

const wpData = inject('wordpressData');
const mainSite = computed(() => wpData?.value?.is_main_site ?? true);
const siteID = computed(() => wpData?.value?.blog_id ?? 1);
const showForm = ref(false);
const showOurStory = ref(false);
const contactInfo = {
  name: '',
  email: '',
  company: '',
};

const credoEntries = ref([]);

withDefaults(defineProps<{
  wordpressData?: any | null,
}>(), {
  wordpressData: null,
});

const handleFormRequest = (payload: any) => {
  contactInfo.name = payload.name;
  contactInfo.email = payload.email;
  contactInfo.company = payload.company;
  showForm.value = true;
};
const openForm = () => {
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};

const queryParams = ref('');
const params = new URLSearchParams(window.location.search);
queryParams.value = params.get('goto') || '';

const baseUrl = window.location.pathname;

const storyEntries = ref([]);
const multisitePath = ref([]);


onMounted(() => {
  watch(showOurStory, (value) => {
    if (value) {
      history.pushState({}, document.title, `${baseUrl}our-story`);
    } else {
      history.pushState({}, document.title, baseUrl);
    }
  });
  window.onpopstate = () => {
    if (showOurStory.value) {
      showOurStory.value = false;
    }
  };

  if (params.get('goto') === 'our-story') {
    showOurStory.value = true;
  }
  axios.get(cdn('json/about-value-credos.json')).then((response) => {
    credoEntries.value = response.data;
  });
  axios.get(cdn('json/our-story-histories.json')).then((response) => {
    storyEntries.value = response.data;
  });

});

</script>

<style scoped>
.spacing {
  height: 320px;
  width: 100%;
}

.hidden {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 820px) {
  .spacing {
    height: 0;
  }
}
</style>
